import type { BackendSessionPayload } from '@sg/backend/src/api/auth/BackendAuthSession.type'
import { Accessor, createMemo, createRoot } from 'solid-js'
import { getSession } from './createSessionSignal'

const getSessionUserId: Accessor<BackendSessionPayload['sub']> = createRoot(() => {
  const getter = createMemo(() => {
    return (getSession())?.sub
  })

  return getter
})

export default getSessionUserId
